export default __webpack_public_path__ + "images/6586ddc1566e2e1b9a9bdf8af116e394-docPlaceholder.png";